export const AVERAGE_COMMISSION_PER_PRODUCT = 74;

export function calculateEarningsGoal({ earningsTarget, sellerCount }) {
  const target = Math.max(0, Number(earningsTarget) || 0);
  const sellers = Math.max(1, Number(sellerCount) || 1);
  const productsNeeded = Math.ceil(target / AVERAGE_COMMISSION_PER_PRODUCT);

  return {
    target,
    sellers,
    productsPerSeller: Math.ceil(productsNeeded / sellers),
  };
}
